<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'Portfolio List - Return' }}</strong>
        </div>
        <div class="col-md-1">
          <!-- <download :tableId="'users'" :fileName="'users-list'"></download> -->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs v-model="selSchemeTab" direction="horizontal" @tab-change="getTabData">
        <v-tab title="Latest">
          <div class="clear-fix"></div>
          <!-- new table XIRR-start -->
          <div class="row">
            <div class="col-md-11">
              <h4 class="font-weight-bold">XIRR</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'usersportfolioxirr'" :fileName="'user-portfolio-xirr'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <spinner v-if="isLoading"></spinner>
            <table id="usersportfolioxirr" class="table-xirr table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="xirr in xirrValues" v-bind:key="'xirr' + xirr.title">{{ xirr.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in xirrData.portfolio" v-bind:key="'row' + index">
                  <td v-for="field in xirrValues" v-bind:key="field.title + index">
                    <span>
                      <span>{{ field.title === 'date' ? row[field.title] : row[field.title]
                        }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
              <br />
              <tbody>
                <tr>
                  <td>{{ 'XIRR' }}</td>
                  <td>{{ xirrData.xirr != undefined ? getFixed(xirrData.xirr.xirr_value) : "" }} %</td>
                </tr>
                <tr>
                  <td>Latest date</td>
                  <td>{{ xirrData.xirr != undefined ? getDate(xirrData.end_date.split("T")[0]) : "" }}</td>
                </tr>
                <tr>
                  <td>First date</td>
                  <td>{{ xirrData.xirr != undefined ? getDate(xirrData.start_date.split("T")[0]) : "" }}</td>
                </tr>
                <tr>
                  <td>Period</td>
                  <td>{{ xirrData.durance != undefined ? xirrData.durance : "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- new table XIRR-end -->
          <!-- Display tables (Datewise values) -->
          <div class="row mt15">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Datewise values)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'divearned'" :fileName="'date-wise-values'"></download>
            </div>
          </div>
          <!-- userStockPortfolioWeightedRelative -->
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <table id="divearned" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in userPFolioDateWiseValuesTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <div v-for="(td, ind) in userStockPortfolioMonthlyData" :key="'tdfi' + ind"
                  v-if="td.transactions.length !== 0" style="display: contents;">
                  <tr v-for="(trans, cIdx) in td.transactions" v-if="td.transactions.length !== 0">
                    <!-- <div style="display: contents;"> -->
                    <td :key="'trans1' + ind + cIdx" v-if="trans.date !== undefined">
                      <span>{{ getDateNew(fixDate(trans.date)) }}</span>
                    </td>
                    <td :key="'trans2' + ind + cIdx" v-if="trans.total_purchases !== undefined">
                      <span>{{ trans.total_purchases == 0 ? "" : trans.total_purchases }}</span>
                    </td>
                    <td :key="'trans3' + ind + cIdx" v-if="trans.total_sales !== undefined">
                      <span>{{ trans.total_sales == 0 ? "" : trans.total_sales }}</span>
                    </td>
                    <td>
                      <span></span>
                    </td>
                    <!-- </div> -->
                  </tr>
                  <tr>
                    <td>
                      <span>{{ getDateNew(fixDate(td.portfolio_e_date)) }}</span>
                    </td>
                    <td>
                      <span></span>
                    </td>
                    <td>
                      <span></span>
                    </td>
                    <td>
                      <span>{{ getFixed(td.portfolio_e) }}</span>
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
          </div>

          <!-- Display tables (Datewise values) -->

          <!-- Display tables (Sub-period return): START -->
          <div class="row mt15">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Sub-period return)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'subperiodtbl'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <table id="subperiodtbl" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in subPeriodReturnTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(td, ind) in userStockPortfolioMonthlyData" :key="'subpertdfi' + ind">
                  <td :key="'subper1' + ind">
                    <span>{{ getDateNew(fixDate(td.portfolio_e_date)) }}</span>
                  </td>
                  <td :key="'subper2' + ind">
                    <span>{{ td.portfolio_b == 0 ? "" : getFixed(td.portfolio_b) }}</span>
                  </td>
                  <td :key="'subper3' + ind">
                    <span>{{ td.monthly_total_purchases == 0 ? "" : td.monthly_total_purchases }}</span>
                  </td>
                  <td :key="'subper4' + ind">
                    <span>{{ td.monthly_total_sales == 0 ? "" : td.monthly_total_sales }}</span>
                  </td>
                  <td :key="'subper5' + ind">
                    <span>{{ td.portfolio_e == 0 ? "" : getFixed(td.portfolio_e) }}</span>
                  </td>
                  <td :key="'subper6' + ind">
                    <span>{{ td.sub_period_return == 0 ? "" : getFixed(td.sub_period_return) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Sub-period return): END -->

          <!-- Display tables (Year wise): START -->
          <div class="row mt15">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Year wise)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'twrryearwisetbl'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <table id="twrryearwisetbl" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in twrrYearWiseTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(twrrTd, twrrIdx) in userStockPortfolioWeightedRelative.yearly_weighted_relative">
                  <td :key="'twrr1' + twrrIdx">
                    <span>{{ twrrTd.year }}</span>
                  </td>
                  <td :key="'twrr2' + twrrIdx">
                    <span>{{ getFixed(twrrTd.twrr) }}</span>
                  </td>
                  <td :key="'twrr3' + twrrIdx">
                    <span>{{ getFixed(twrrTd["twrr_%"]) }}</span>
                  </td>
                  <td :key="'twrr4' + twrrIdx">
                    <span>{{ getFixed(twrrTd.weighted) }}</span>
                  </td>
                </tr>
                <tr></tr>
              </tbody>
              <br>
              <tbody>
                <tr>
                  <td>Cumulative Wealth Relative</td>
                  <td>{{ getFixed(userStockPortfolioWeightedRelative.cumulative_weighted_relative) }}</td>
                </tr>
                <tr>
                  <td>No of years</td>
                  <td>{{ userStockPortfolioWeightedRelative.number_of_years }}</td>
                </tr>
                <tr>
                  <td>TWRR(Yearly)</td>
                  <td>{{ userStockPortfolioWeightedRelative.twrr_yearly }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Year wise): END -->
        </v-tab>
        <v-tab title="Date-wise Return">
          <div class="clear-fix"></div>
          <!-- new table XIRR-start -->
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <v-select :options="filterDateData" :placeholder="'Select Date'" v-model="ddate"
                  @input="getSelDate($event)"></v-select>
              </div>
            </div>
            <div class="col-md-11" v-if="dateWiseReturnData.xirr != undefined">
              <h4 class="font-weight-bold">XIRR</h4>
            </div>
            <div class="col-md-1" v-if="dateWiseReturnData.xirr != undefined">
              <download :tableId="'usersportfolioxirr'" :fileName="'user-portfolio-xirr'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true" v-if="dateWiseReturnData.xirr != undefined">
            <spinner v-if="isLoading"></spinner>
            <table id="usersportfolioxirr" class="table-xirr table table-sm first-td-padding table-bordered app-inner">
              <!-- <thead>
                <tr>
                  <th v-for="xirr in xirrValues" v-bind:key="'xirr' + xirr.title">{{ xirr.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in xirrData.portfolio" v-bind:key="'row' + index">
                  <td v-for="field in xirrValues" v-bind:key="field.title + index">
                    <span>
                      <span>{{ row[field.title] }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
              <br />-->
              <tbody>
                <tr>
                  <td>{{ 'XIRR' }}</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ? getFixed(dateWiseReturnData.xirr.xirr_value) : "" }} %
                  </td>
                </tr>
                <tr>
                  <td>Latest date</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ? getDate(dateWiseReturnData.xirr.end_date.split("T")[0])
                    : "" }}</td>
                </tr>
                <tr>
                  <td>First date</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ?
                    getDate(dateWiseReturnData.xirr.start_date.split("T")[0]) : "" }}</td>
                </tr>
                <tr>
                  <td>Period</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ? dateWiseReturnData.xirr.durance : "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- new table XIRR-end -->

          <!-- Display tables (Sub-period return): START -->
          <div class="row mt15"
            v-if="dateWiseReturnData.sub_period_return != undefined && dateWiseReturnData.sub_period_return.length > 0">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Sub-period return)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'subperdatewisetdfi'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true"
            v-if="dateWiseReturnData.sub_period_return != undefined && dateWiseReturnData.sub_period_return.length > 0">
            <table id="subperdatewisetdfi" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in subPeriodReturnFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(td, ind) in dateWiseReturnData.sub_period_return" :key="'subperdatewisetdfi' + ind">
                  <td :key="'subperdatewise1' + ind">
                    <span>{{ getDateNew(fixDate(td.portfolio_e_date)) }}</span>
                  </td>
                  <td :key="'subperdatewise2' + ind">
                    <span>{{ td.sub_period_return == 0 ? "" : getFixed(td.sub_period_return) }}</span>
                  </td>
                  <td :key="'subperdatewise3' + ind">
                    <span>{{ td.monthly_weighted_relative == 0 ? "" : getFixed(td.monthly_weighted_relative) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Sub-period return): END -->

          <!-- Display tables (Year wise): START -->
          <div class="row mt15"
            v-if="dateWiseReturnData.yearly_weighted_relative != undefined && dateWiseReturnData.yearly_weighted_relative.length > 0">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Year wise)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'twrryearwisetbldate'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true"
            v-if="dateWiseReturnData.yearly_weighted_relative != undefined && dateWiseReturnData.yearly_weighted_relative.length > 0">
            <table id="twrryearwisetbldate" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in twrrYearWiseTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- TAB-2 -->
                <tr v-for="(twrrTd, twrrIdx) in dateWiseReturnData.yearly_weighted_relative">
                  <td :key="'twrr1' + twrrIdx">
                    <span>{{ twrrTd.year }}</span>
                  </td>
                  <td :key="'twrr2' + twrrIdx">
                    <span>{{ getFixed(twrrTd.twrr) }}</span>
                  </td>
                  <td :key="'twrr3' + twrrIdx">
                    <span>{{ getFixed(twrrTd["twrr_%"]) }}</span>
                  </td>
                  <td :key="'twrr4' + twrrIdx">
                    <span>{{ getFixed(twrrTd.weighted) }}</span>
                  </td>
                </tr>
                <tr></tr>
              </tbody>
              <br>
              <tbody>
                <tr>
                  <td>Cumulative Wealth Relative</td>
                  <td>{{ getFixed(dateWiseReturnData.cumulative_weighted_relative) }}</td>
                </tr>
                <tr>
                  <td>No of years</td>
                  <td>{{ dateWiseReturnData.number_of_years }}</td>
                </tr>
                <tr>
                  <td>TWRR(Yearly)</td>
                  <td>{{ dateWiseReturnData.twrr_yearly }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Year wise): END -->
        </v-tab>
      </vue-tabs>


    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import spinner from "@/components/spinner";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: { spinner },
  mixins: [commonMixins],
  name: "UserReturns",
  props: ["user"],
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "user-listing" });
    }
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.userId = this.$route.params.id;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "");
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    console.log('=> Cur TAB: created: ', this.selSchemeTab, this.searchParams);
    let setIntTimeout = setTimeout(() => {
      clearTimeout(setIntTimeout);
      if (this.selSchemeTab === "Latest") {
        this.fetchData(this.searchParams);
        this.fetchXIRRData();
      }
    }, 1000);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "frontend/getUserStockPortfolioMonthly",
      apiMode: true,
      isLoading: false,
      curDate: ("0" + (new Date().getDate())).slice(-2) + '-' + ("0" + (new Date().getMonth() + 1)).slice(-2) + '-' + new Date().getFullYear(),
      company: {},
      selSchemeTab: "",
      actions: [],
      xirrData: {},
      ddate: "",
      filterDateData: [],
      dateWiseReturnData: {},
      /* dateWiseReturnData:
      {
        "_id": "671b402582fdd222d3a95fcb",
        "user_id": 166.0,
        "insert_date": "2024-25-10T06:52:19",
        "xirr": {
          "xirr_value": 35.05414707526291,
          "date": "2019-11-09T00:00:00",
          "start_date": "2019-11-09T00:00:00",
          "end_date": "2024-25-10T00:00:00",
          "durance": "5.12 Years"
        },
        "sub_period_return": [
          {
            "portfolio_e_date": "2019-30-09T00:00:00",
            "sub_period_return": 5.85,
            "monthly_weighted_relative": 6.85
          },
          {
            "portfolio_e_date": "2019-31-10T00:00:00",
            "sub_period_return": 2.0278157830442214,
            "monthly_weighted_relative": 3.0278157830442214
          },
          {
            "portfolio_e_date": "2019-29-11T00:00:00",
            "sub_period_return": -0.03186514804907651,
            "monthly_weighted_relative": 0.9681348519509235
          },
          {
            "portfolio_e_date": "2019-31-12T00:00:00",
            "sub_period_return": 0.03505182135281438,
            "monthly_weighted_relative": 1.0350518213528144
          },
          {
            "portfolio_e_date": "2020-31-01T00:00:00",
            "sub_period_return": -0.010532673028143437,
            "monthly_weighted_relative": 0.9894673269718566
          },
          {
            "portfolio_e_date": "2020-28-02T00:00:00",
            "sub_period_return": -0.017480895529676105,
            "monthly_weighted_relative": 0.9825191044703239
          },
          {
            "portfolio_e_date": "2020-31-03T00:00:00",
            "sub_period_return": -0.22810592318332792,
            "monthly_weighted_relative": 0.7718940768166721
          },
          {
            "portfolio_e_date": "2020-30-04T00:00:00",
            "sub_period_return": 0.08907608112458422,
            "monthly_weighted_relative": 1.0890760811245843
          },
          {
            "portfolio_e_date": "2020-29-05T00:00:00",
            "sub_period_return": -0.071144239390685,
            "monthly_weighted_relative": 0.928855760609315
          },
          {
            "portfolio_e_date": "2020-30-06T00:00:00",
            "sub_period_return": 0.017958958528914253,
            "monthly_weighted_relative": 1.0179589585289142
          },
          {
            "portfolio_e_date": "2020-31-07T00:00:00",
            "sub_period_return": 0.02992804555898846,
            "monthly_weighted_relative": 1.0299280455589885
          },
          {
            "portfolio_e_date": "2020-31-08T00:00:00",
            "sub_period_return": -0.3670204428354005,
            "monthly_weighted_relative": 0.6329795571645995
          },
          {
            "portfolio_e_date": "2020-30-09T00:00:00",
            "sub_period_return": 1.1496744817669848,
            "monthly_weighted_relative": 2.1496744817669846
          },
          {
            "portfolio_e_date": "2020-30-10T00:00:00",
            "sub_period_return": 0.06359519451043995,
            "monthly_weighted_relative": 1.06359519451044
          },
          {
            "portfolio_e_date": "2020-27-11T00:00:00",
            "sub_period_return": 0.12035101269025383,
            "monthly_weighted_relative": 1.1203510126902538
          },
          {
            "portfolio_e_date": "2020-31-12T00:00:00",
            "sub_period_return": 0.1048404350151543,
            "monthly_weighted_relative": 1.1048404350151544
          },
          {
            "portfolio_e_date": "2021-29-01T00:00:00",
            "sub_period_return": -0.05087366838522646,
            "monthly_weighted_relative": 0.9491263316147736
          },
          {
            "portfolio_e_date": "2021-26-02T00:00:00",
            "sub_period_return": 0.037259107923617314,
            "monthly_weighted_relative": 1.0372591079236173
          },
          {
            "portfolio_e_date": "2021-31-03T00:00:00",
            "sub_period_return": 0.022185130144022038,
            "monthly_weighted_relative": 1.0221851301440221
          },
          {
            "portfolio_e_date": "2021-30-04T00:00:00",
            "sub_period_return": -0.009842935295328417,
            "monthly_weighted_relative": 0.9901570647046716
          },
          {
            "portfolio_e_date": "2021-31-05T00:00:00",
            "sub_period_return": 0.11252543900845917,
            "monthly_weighted_relative": 1.1125254390084591
          },
          {
            "portfolio_e_date": "2021-30-06T00:00:00",
            "sub_period_return": -0.0012664247035309207,
            "monthly_weighted_relative": 0.9987335752964691
          },
          {
            "portfolio_e_date": "2021-30-07T00:00:00",
            "sub_period_return": -0.029861876976742956,
            "monthly_weighted_relative": 0.9701381230232571
          },
          {
            "portfolio_e_date": "2021-31-08T00:00:00",
            "sub_period_return": 0.09479954628426362,
            "monthly_weighted_relative": 1.0947995462842637
          },
          {
            "portfolio_e_date": "2021-30-09T00:00:00",
            "sub_period_return": 0.0011550011550009885,
            "monthly_weighted_relative": 1.001155001155001
          },
          {
            "portfolio_e_date": "2021-29-10T00:00:00",
            "sub_period_return": -0.044754842220293516,
            "monthly_weighted_relative": 0.9552451577797065
          },
          {
            "portfolio_e_date": "2021-30-11T00:00:00",
            "sub_period_return": -0.034049101541229435,
            "monthly_weighted_relative": 0.9659508984587706
          },
          {
            "portfolio_e_date": "2021-31-12T00:00:00",
            "sub_period_return": 0.04128350424501448,
            "monthly_weighted_relative": 1.0412835042450146
          },
          {
            "portfolio_e_date": "2022-31-01T00:00:00",
            "sub_period_return": 3.766017342523564e-05,
            "monthly_weighted_relative": 1.0000376601734253
          },
          {
            "portfolio_e_date": "2022-28-02T00:00:00",
            "sub_period_return": -0.02015920238756491,
            "monthly_weighted_relative": 0.9798407976124351
          },
          {
            "portfolio_e_date": "2022-31-03T00:00:00",
            "sub_period_return": 0.0032548408250717732,
            "monthly_weighted_relative": 1.0032548408250719
          },
          {
            "portfolio_e_date": "2022-29-04T00:00:00",
            "sub_period_return": -0.004304957644771457,
            "monthly_weighted_relative": 0.9956950423552285
          },
          {
            "portfolio_e_date": "2022-31-05T00:00:00",
            "sub_period_return": -0.06957870437166337,
            "monthly_weighted_relative": 0.9304212956283366
          },
          {
            "portfolio_e_date": "2022-30-06T00:00:00",
            "sub_period_return": -0.052891387219745616,
            "monthly_weighted_relative": 0.9471086127802544
          },
          {
            "portfolio_e_date": "2022-29-07T00:00:00",
            "sub_period_return": 0.15995743055176564,
            "monthly_weighted_relative": 1.1599574305517657
          },
          {
            "portfolio_e_date": "2022-30-08T00:00:00",
            "sub_period_return": 0.3805220657952089,
            "monthly_weighted_relative": 1.3805220657952089
          },
          {
            "portfolio_e_date": "2022-30-09T00:00:00",
            "sub_period_return": -0.026272703600025853,
            "monthly_weighted_relative": 0.9737272963999741
          },
          {
            "portfolio_e_date": "2022-31-10T00:00:00",
            "sub_period_return": 0.033152216240221064,
            "monthly_weighted_relative": 1.0331522162402211
          },
          {
            "portfolio_e_date": "2022-30-11T00:00:00",
            "sub_period_return": 0.03494622793606779,
            "monthly_weighted_relative": 1.0349462279360677
          },
          {
            "portfolio_e_date": "2022-30-12T00:00:00",
            "sub_period_return": -0.018788045971311267,
            "monthly_weighted_relative": 0.9812119540286888
          },
          {
            "portfolio_e_date": "2023-31-01T00:00:00",
            "sub_period_return": -0.06219772104052667,
            "monthly_weighted_relative": 0.9378022789594733
          },
          {
            "portfolio_e_date": "2023-28-02T00:00:00",
            "sub_period_return": 0.010567086617302763,
            "monthly_weighted_relative": 1.0105670866173027
          },
          {
            "portfolio_e_date": "2023-31-03T00:00:00",
            "sub_period_return": 0.00593724512226302,
            "monthly_weighted_relative": 1.005937245122263
          },
          {
            "portfolio_e_date": "2023-28-04T00:00:00",
            "sub_period_return": 0.03909111452320143,
            "monthly_weighted_relative": 1.0390911145232014
          },
          {
            "portfolio_e_date": "2023-31-05T00:00:00",
            "sub_period_return": 0.046354851588199464,
            "monthly_weighted_relative": 1.0463548515881995
          },
          {
            "portfolio_e_date": "2023-30-06T00:00:00",
            "sub_period_return": 0.03786768526467455,
            "monthly_weighted_relative": 1.0378676852646747
          },
          {
            "portfolio_e_date": "2023-31-07T00:00:00",
            "sub_period_return": 0.0070864988015435755,
            "monthly_weighted_relative": 1.0070864988015436
          },
          {
            "portfolio_e_date": "2023-31-08T00:00:00",
            "sub_period_return": -0.06178258240318146,
            "monthly_weighted_relative": 0.9382174175968185
          },
          {
            "portfolio_e_date": "2023-29-09T00:00:00",
            "sub_period_return": 0.03819473923400782,
            "monthly_weighted_relative": 1.0381947392340078
          },
          {
            "portfolio_e_date": "2023-31-10T00:00:00",
            "sub_period_return": -0.01358676889010611,
            "monthly_weighted_relative": 0.9864132311098939
          },
          {
            "portfolio_e_date": "2023-30-11T00:00:00",
            "sub_period_return": 0.04844690099806628,
            "monthly_weighted_relative": 1.0484469009980664
          },
          {
            "portfolio_e_date": "2023-29-12T00:00:00",
            "sub_period_return": 0.07461127401056215,
            "monthly_weighted_relative": 1.0746112740105622
          },
          {
            "portfolio_e_date": "2024-31-01T00:00:00",
            "sub_period_return": -0.055838797774696074,
            "monthly_weighted_relative": 0.944161202225304
          },
          {
            "portfolio_e_date": "2024-29-02T00:00:00",
            "sub_period_return": -0.02622451804385735,
            "monthly_weighted_relative": 0.9737754819561426
          },
          {
            "portfolio_e_date": "2024-28-03T00:00:00",
            "sub_period_return": 0.014244835828303574,
            "monthly_weighted_relative": 1.0142448358283036
          },
          {
            "portfolio_e_date": "2024-30-04T00:00:00",
            "sub_period_return": 0.05269926385932058,
            "monthly_weighted_relative": 1.0526992638593207
          },
          {
            "portfolio_e_date": "2024-31-05T00:00:00",
            "sub_period_return": -0.006397346997011266,
            "monthly_weighted_relative": 0.9936026530029888
          },
          {
            "portfolio_e_date": "2024-28-06T00:00:00",
            "sub_period_return": 0.06451084145220434,
            "monthly_weighted_relative": 1.0645108414522044
          },
          {
            "portfolio_e_date": "2024-31-07T00:00:00",
            "sub_period_return": -0.006839667595972514,
            "monthly_weighted_relative": 0.9931603324040275
          },
          {
            "portfolio_e_date": "2024-30-08T00:00:00",
            "sub_period_return": 0.005924056458120313,
            "monthly_weighted_relative": 1.0059240564581202
          },
          {
            "portfolio_e_date": "2024-30-09T00:00:00",
            "sub_period_return": 0.048442678775292375,
            "monthly_weighted_relative": 1.0484426787752923
          },
          {
            "portfolio_e_date": "2024-11-10T00:00:00",
            "sub_period_return": 0.3908701926315849,
            "monthly_weighted_relative": 1.390870192631585
          }
        ],
        "yearly_weighted_relative": [
          {
            "year": "2019",
            "twrr": 18.783465673100412,
            "twrr_%": "1878.35%",
            "weighted": 19.783465673100412
          },
          {
            "year": "2020",
            "twrr": -0.5742734242391581,
            "twrr_%": "-57.43%",
            "weighted": 0.42572657576084194
          },
          {
            "year": "2021",
            "twrr": -0.8688689755435204,
            "twrr_%": "-86.89%",
            "weighted": 0.13113102445647962
          },
          {
            "year": "2022",
            "twrr": -0.5889039146122979,
            "twrr_%": "-58.89%",
            "weighted": 0.41109608538770215
          },
          {
            "year": "2023",
            "twrr": -0.8271897691449397,
            "twrr_%": "-82.72%",
            "weighted": 0.1728102308550603
          },
          {
            "year": "2024",
            "twrr": 0.512623322522423,
            "twrr_%": "51.26%",
            "weighted": 1.512623322522423
          }
        ],
        "cumulative_weighted_relative": 139.37306386016144,
        "number_of_years": 5,
        "twrr_yearly": "168.43%"
      }, */
      subPeriodReturnFields: [{ title: "Portfolio E Date", name: "portfolio_e_date", type: "date" }, { title: "Sub Period Return", name: "sub_period_return", type: "number" }, { title: "Monthly Weighted Relative", name: "monthly_weighted_relative", type: "number" }],
      xirrValues: [{ title: "date", name: "Date", type: "date" }, { title: "purchase", name: "Cash flows", type: "number" }],
      divEarnedTableFields: [
        {
          title: "year",
          name: "Year",
          isNumeric: true
        },
        {
          title: "no_of_share_held",
          name: "No. of Shares Held",
          isNumeric: true
        },
        {
          title: "dividend_per_share",
          name: "Dividend per share",
          isNumeric: true
        },
        { title: "dividend_earned", name: "Dividend Earned", isNumeric: true }
      ],
      userPFolioDateWiseValuesTblFields: [
        {
          name: "date",
          title: "Date",
          isNumeric: 0
        },
        {
          name: "total_purchases",
          title: "Purchase V",
          isNumeric: 1
        },
        {
          name: "total_sales",
          title: "Sale Value",
          isNumeric: 1
        },
        {
          name: "portfolio_e",
          title: "Portfolio E",
          isNumeric: 1
        },
      ],
      subPeriodReturnTblFields: [
        {
          name: "portfolio_e_date",
          title: "Date",
          isNumeric: 0
        },
        {
          name: "portfolio_b",
          title: "Portfolio B",
          isNumeric: 1
        },
        {
          name: "monthly_total_purchases",
          title: "Purchase",
          isNumeric: 1
        },
        {
          name: "monthly_total_sales",
          title: "Sale",
          isNumeric: 1
        },
        {
          name: "portfolio_e",
          title: "Portfolio E",
          isNumeric: 1
        },
        {
          name: "sub_period_return",
          title: "Sub-period Return",
          isNumeric: 1
        }
      ],
      subPeriodReturnTblFieldsDateWise: [
        {
          name: "portfolio_e_date",
          title: "Date",
          isNumeric: 0
        },
        {
          name: "sub_period_return",
          title: "Sub-period Return",
          isNumeric: 1
        },
        {
          name: "monthly_weighted_relative",
          title: "Monthly Weighted Relative",
          isNumeric: 1
        }
      ],
      twrrYearWiseTblFields: [
        {
          name: "year",
          title: "Year",
          isNumeric: 0
        },
        {
          name: "twrr",
          title: "TWRR",
          isNumeric: 1
        },
        {
          name: "twrr_%",
          title: "TWRR (%)",
          isNumeric: 1
        },
        {
          name: "weighted",
          title: "Wealth Relative",
          isNumeric: 1
        }
      ],
      searchParams: {},
      userStockPortfolioWeightedRelative: [],
      userStockPortfolioMonthlyData: [],
      userStockPortfolioTWRRData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      userId: 0
    };
  },
  methods: {
    reset() {
      // window.location.reload();
      this.$router.push({ name: "user-listing" });
      this.searchParams = { userid: this.userId };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      if (this.ddate != null) {
        this.fetchDateWiseReturnData();
      } else {
        this.dateWiseReturnData = {};
      }
      //this.getRawData();
    },
    getFilterDate() {

      let myself = this;
      //https://api.nobiasinvesting.com/frontend/filter-date?collection_name=twrr-xirr-return
      http.get(`frontend/filter-date?collection_name=twrr-xirr-return`, {}, function (error, response) {
        console.log("response", response);
        if (response.responseType === "success") {
          myself.filterDateData = response.date;
        }
      });
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log("TAB Change::: ", tabIndex, newTab.value, newTab.title);
      if (tabIndex === 0) {
        this.fetchData(this.searchParams);
        this.fetchXIRRData();

      } else if (tabIndex === 1) {
        //this.fetchData(this.searchParams);
        this.xirrData = {};
        this.userStockPortfolioMonthlyData = [];
        this.userStockPortfolioWeightedRelative = [];
        this.getFilterDate();
        //this.fetchDateWiseReturnData();
      }
      this.selSchemeTab = newTab.title;
    },
    fetchData(data) {
      if (this.url !== "") {
        //console.log("url =====" + this.url + "========");
        let myself = this;
        //myself.isLoading = true;
        let params = data ? { userid: this.userId } : {};
        http.post(this.url, params, function (error, response) {
          for (let d in response) {
            if (Array.isArray(response[d]) && d !== 'yearly_weighted_relative') {
              myself.userStockPortfolioMonthlyData.push(response[d][0]);
            } else {
              //console.log("###### >>>", [d], response[d]);
              myself.userStockPortfolioWeightedRelative[d] = response[d];
            }
            //myself.isLoading = false;
          }
          //console.log('###### >>>', myself.userStockPortfolioWeightedRelative);
        });
      } else {
        //console.log("=====" + this.url + "========");

      }
    },
    fetchXIRRData() {
      let myself = this;
      myself.isLoading = true;
      http.post("frontend/getUserStockPortfolio", { "userid": myself.userId }, function (error, response) {
        //console.log(">>> getUserStockPortfolio: ", response);
        // if (response.responseType === "success") {
        myself.xirrData = response;
        const resTimeUtl = setTimeout(function () {
          clearTimeout(resTimeUtl);
          myself.isLoading = false;
        }, 4000);
      });
    },
    fetchDateWiseReturnData() {
      let myself = this;
      myself.isLoading = true;
      //user_portfolio_twrr_or_xirr/get?user_id=166&date=2024-10-25
      http.get(`user_portfolio_twrr_or_xirr/get?user_id=${myself.userId}&date=${myself.ddate}`, {}, function (error, response) {
        console.log("response", response);
        if (response.status === "success") {
          myself.dateWiseReturnData = response.data[0];
          //myself.xirrData.xirr = myself.dateWiseReturnData.xirr;
          const resTimeUtl = setTimeout(function () {
            clearTimeout(resTimeUtl);
            myself.isLoading = false;
          }, 2000);
        }
      });
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      //this.fillableData.splice(index, 1);
    },
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}

.table-xirr {
  width: auto;
}

.row {
  align-items: center;
}

.tab-content {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/user-returns.vue